import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { StyledQuestionTitle, StyledLabel, StyledInput } from './ArticleQuestion.styles';

function ArticleQuestion({ question, id }) {
  const [answer, setAnswer] = useState(null);
  const selectedAnswer = useRef();

  const sendData = () => {
    selectedAnswer.current &&
      `Selected answer is '${selectedAnswer.current}' for article ID: ${id}`;
  };

  useEffect(() => {
    selectedAnswer.current = answer;
  }, [answer]);

  useEffect(() => sendData(), []);

  const onChange = e => {
    setAnswer(e.target.value);
  };

  if (!question) return null;

  return (
    <div>
      <StyledQuestionTitle>{question.title}</StyledQuestionTitle>
      <form>
        {question.options.map(content => (
          <StyledLabel key={content.value}>
            <StyledInput
              type="radio"
              name="articleQuestion"
              value={content.value}
              onChange={onChange}
            />
            {content.text}
          </StyledLabel>
        ))}
      </form>
    </div>
  );
}

ArticleQuestion.propTypes = {
  question: PropTypes.shape({
    title: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      })
    ).isRequired,
  }),
  id: PropTypes.number,
};

export default ArticleQuestion;
